var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_5793)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.7359 13.47C36.7359 11.4411 35.0912 9.79639 33.0623 9.79639C31.0334 9.79639 29.3887 11.4411 29.3887 13.47V37.9607C29.3887 39.9896 31.0334 41.6343 33.0623 41.6343C35.0912 41.6343 36.7359 39.9896 36.7359 37.9607V13.47Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.4908 25.7154C24.4908 23.6865 22.846 22.0417 20.8172 22.0417C18.7883 22.0417 17.1436 23.6865 17.1436 25.7154V37.9607C17.1436 39.9896 18.7883 41.6343 20.8172 41.6343C22.846 41.6343 24.4908 39.9896 24.4908 37.9607V25.7154Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2453 46.5324H48.9814C50.334 46.5324 51.4305 47.6288 51.4305 48.9814C51.4305 50.334 50.334 51.4305 48.9814 51.4305H9.79624C8.44366 51.4305 7.34717 50.334 7.34717 48.9814V9.79624C7.34717 8.44366 8.44366 7.34717 9.79624 7.34717C11.1488 7.34717 12.2453 8.44366 12.2453 9.79624V46.5324Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.9815 30.6133C48.9815 28.5844 47.3368 26.9397 45.3079 26.9397C43.279 26.9397 41.6343 28.5844 41.6343 30.6133V37.9605C41.6343 39.9894 43.279 41.6341 45.3079 41.6341C47.3368 41.6341 48.9815 39.9894 48.9815 37.9605V30.6133Z",
    fill: "#B0B7C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_5793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.7778,
    height: 58.7778,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/Leaderboard.bc244a409b986a82ba3969e233872e33.svg";
export { ForwardRef as ReactComponent };